import { IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useMemo } from 'react';
import { useRemoveFavorite } from '~/hooks/vdp/favorites';
import { ListenerEvent, type ListenerEventType } from './constants';

type RemoveFavoritePayload = {
  stockNumber: number;
  vehicleId: number;
};

function isRemoveFavoriteMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, RemoveFavoritePayload> {
  return (
    message.event === ListenerEvent.RemoveFavorite &&
    message.payload.stockNumber != null &&
    message.payload.vehicleId != null
  );
}

export default function useRemoveFavoriteHandler(): MessageHandler<
  ListenerEventType,
  RemoveFavoritePayload
> {
  const removeFavorite = useRemoveFavorite();

  return useMemo(
    () =>
      new MessageHandler(isRemoveFavoriteMessage, message => {
        void removeFavorite(message.payload);
      }),
    [removeFavorite]
  );
}
